import { CheckBox, IconButton, keyframes, styled } from '@clickcease/cc-client-components-lib'

const goIn = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1, visibility: 'visible' },
})

export const FiltersContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '6px 0px',
  width: '300px',
  minHeight: '150px',
  maxHeight: '500px',
  overflowY: 'auto',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${goIn} ease-in 0.3s`,
  transition: 'all 0.3s ease',
})
export const FiltersHeader = styled('div', {
  borderBottom: '1px solid #e5e5e5',
  color: '$disabled',
  boxShadow: 'rgb(245, 245, 245) 0px 3px 4px',
  fontSize: '$md',
  padding: '5px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})
export const FilterSection = styled('div', {
  fontSize: '$md',
  cursor: 'pointer',
  padding: '$4 $12',
  '&:hover': {
    backgroundColor: '$tableHovered',
    color: '$primaryColor',
  },
})

export const FilterTitleText = styled('span', {})

export const OptionsWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  maxHeight: '200px',
  overflowY: 'auto',
  paddingRight: '8px',
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  animation: `${goIn} ease-in 0.3s`,
  transition: 'all 0.3s ease',
})

export const CheckboxItem = styled('div', {
  padding: '$4 $12',
  marginTop: '6px',
  '&:hover': {
    backgroundColor: '#FFF5F9',
  },
  '& > div': {
    alignItems: 'center',
  },
})

export const StyledCheckBox = styled(CheckBox, {})

export const IconButtonStyled = styled(IconButton, {
  position: 'absolute',
  left: '10px',
})

export const ActionButton = styled('button', {
  padding: '8px 16px',
  borderRadius: '4px',
  fontSize: '14px',
  fontWeight: 500,
  cursor: 'pointer',
  background: '$buttonBackgroundColor',
  color: '$white',
  border: 'none',
  '&:hover': {
    opacity: '0.8',
  },
})
